if (!customElements.get("sq-outro")) {
  class SQOutro extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    
    connectedCallback() {
      // Remove initSwipers call from here since it's now in init()
    }

    init() {
      this.selectors = {
        productCarousel: this.querySelector('.product-carousel'),
        outroCarousel: this.querySelector('.outro-carousel')
      };

      Object.assign(this, {
        productSwiper: null,
        outroSwiper: null
      });

      this.initSwipers();
    }

    initSwipers() {
      if (this.selectors.productCarousel) {
        this.productSwiper = new MinimogLibs.Swiper(this.selectors.productCarousel, {
          slidesPerView: 1,
          spaceBetween: 32,
          allowTouchMove: true,
          loopFillGroupWithBlank: true,
          centeredSlides: true,
          loop: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 16,
            },
            800: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            1280: {
              slidesPerView: 2,
              spaceBetween: 32,
            },
          },
        });
      }

      if (this.selectors.outroCarousel) {
        this.outroSwiper = new MinimogLibs.Swiper(this.selectors.outroCarousel, {
          slidesPerView: 1.5,
          spaceBetween: 32,
          a11y: true,
          a11y: {
          enabled: true,
          prevSlideMessage: "Prev Slide",
          nextSlideMessage: "Nex Slide",
          paginationBulletMessage: "Move Slide {{index}}",
          },
          keyboard: { enabled: true },
          allowTouchMove: true,
          breakpoints: {
            640: {
              slidesPerView: 1.5,
              spaceBetween: 32,
            },
            800: {
              slidesPerView: 2,
              spaceBetween: 32,
            },
            1280: {
              slidesPerView: 2,
              spaceBetween: 32,
            },
          },
        });
      }
    }
  }

  customElements.define("sq-outro", SQOutro);
}